import React from 'react';
import { PostData } from './Posts';
import { Link } from 'gatsby';
import cx from 'classnames';
// import { Link } from '@reach/router';

interface PostProps {
  title: string;
  excerpt: string;
  image: string;
  categories: Array<{
    name: string;
  }>;
  author: PostData['author'];
  slug: string;
  isRelated?: boolean;
}

const Post = ({ title, excerpt, image, author, categories, slug, isRelated }: PostProps) => {
  return (
    <Link
      className={cx('post-card', {
        'post-card--related': isRelated,
      })}
      to={slug}
    >
      <div className="post-card__image" style={{ backgroundImage: `url(${image})` }} />
      <div className="post-card__content">
        <div className="post-card__categories">
          {categories.map((cat, index) => (
            <div key={index} className="post-card__category">
              {cat.name}
            </div>
          ))}
        </div>
        <h3 className="post-card__title">{title}</h3>
        <div className="post-card__text">{excerpt}</div>
        <div className="post-card__author">
          <img
            src={author.profile_picture}
            alt="img"
            width="18px"
            height="18px"
            className="post-card__logo"
          />
          <div className="post-card__name u-color-lavender">{author.name}</div>
        </div>
      </div>
    </Link>
  );
};

export default Post;
